<!--
 * @Description: 
 * @Author: HG
 * @Date: 2019-08-08 17:38:24
 * @LastEditors: HG
 * @LastEditTime: 2019-08-13 16:17:30
 -->
<template>
  <div class="container">
    <head-nav-bar title="住院费用每日清单" :fixed="true" />
    <div class="mt-header-nav">
      <detaile-head :info="info" />

      <div class="kong"></div>
      <list-head-date-picker v-model="totalDate" @change="onDateChange" />
      <DataList api="InHospital_Detaile" :params="listParams">
        <template v-slot:item="item">
          <van-cell>
            <div slot="title">
              <div>
                <span>{{ item.obj.chargeItem }}</span>
              </div>
            </div>
            <div class="value">
              <span class="money">￥{{ item.obj.amount }}</span> ×
              <span class="num">{{ item.obj.count }}{{ item.obj.unit }}</span>
            </div>
          </van-cell>
        </template>
      </DataList>
    </div>
  </div>
</template>

<script>
import { Button, Cell, Icon } from "vant";
import ListHeadDatePicker from "@/components/ListHeadDatePicker";
import DataList from "@/components/DataList";
import { formatDate } from "@/utils/common";
import DetaileHead from "./DetailedHead";

export default {
  name: "Confirm",
  components: {
    DataList,
    DetaileHead,
    ListHeadDatePicker,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Icon.name]: Icon,
  },
  computed: {},
  data() {
    return {
      queryParams: {},
      info: {},
      tabActive: "",
      totalDate: formatDate(),
      detaileDate: formatDate(),
      listParams: {},
    };
  },
  created() {
    this.getInfo(this.$route.query.diagnosisCardNo);
    this.queryParams = this.$route.query;
    this.listParams = this.queryParams;
    this.totalDate = this.queryParams.costDate;
  },
  methods: {
    getInfo(DiagnosisCardNo) {
      this.$post("InHospital_Info", {
        DiagnosisCardNo: DiagnosisCardNo,
      }).then(res => {
        this.info = res.data;
      });
    },
    onDateChange(date) {
      console.log(date);
      const arr = { ...this.queryParams };
      arr.costDate = date;
      this.listParams = arr;
    },
  },
};
</script>

<style lang="less"></style>
